"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.mnemonicToPrivateKey = void 0;
const hdkey_1 = require("ethereum-cryptography/hdkey");
const bip39_1 = require("ethereum-cryptography/bip39");
const utils_1 = require("ethereum-cryptography/utils");
const getPath = (index = 0) => {
    return `m/44'/60'/0'/0/${index}`;
};
const mnemonicToPrivateKey = (mnemonic, derivationIndex) => {
    const seed = (0, bip39_1.mnemonicToSeedSync)(mnemonic);
    const path = getPath(derivationIndex);
    const node = hdkey_1.HDKey.fromMasterSeed(seed).derive(path);
    const privateKey = (0, utils_1.bytesToHex)(node.privateKey);
    return privateKey;
};
exports.mnemonicToPrivateKey = mnemonicToPrivateKey;
